import { CoreHelperUtil } from '@reown/appkit';

(CoreHelperUtil as any).isTelegram = function () {
    if (typeof window === 'undefined') return false;

    try {
        const inIframe = window.self !== window.top;
        const win = window as any;

        return (
            inIframe &&
            (Boolean(win.TelegramWebviewProxy) ||
                Boolean(win.Telegram) ||
                Boolean(win.TelegramWebviewProxyProto))
        );
    } catch {
        return false;
    }
};
